<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-header">
                        <h4 class="card-title">New Buyer</h4>
                        <h6 class="card-subtitle">Invite a new buyer</h6>
                    </div>
                    <form @submit.prevent="handleSubmit" class="form-horizontal">
                        <div class="card-body card-blue">
                            <h6 class="card-title">Personal Info</h6>

                            <div class="form-group row">
                                <label class="col-sm-3 text-right control-label col-form-label" for="first_name">Contact Name</label>
                                <div class="col-sm-3">
                                    <input :class="{'is-invalid': submitted && errors.has('first_name')}" class="form-control"
                                           data-vv-as="First Name"
                                           id="first_name"
                                           name="first_name"
                                           placeholder="First Name"
                                           type="text"
                                           v-model="partner.first_name"
                                           v-validate="'required'">
                                    <div class="invalid-feedback" v-if="submitted && errors.has('first_name')">{{ errors.first('first_name') }}</div>
                                </div>
                                <div class="col-sm-3">
                                    <input :class="{'is-invalid': submitted && errors.has('last_name')}" class="form-control"
                                           data-vv-as="Last Name"
                                           id="last_name"
                                           name="last_name"
                                           placeholder="Last Name"
                                           type="text"
                                           v-model="partner.last_name"
                                           v-validate="'required'">
                                    <div class="invalid-feedback" v-if="submitted && errors.has('last_name')">{{ errors.first('last_name') }}</div>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-3 text-right control-label col-form-label" for="email">Contact Email</label>
                                <div class="col-sm-3">
                                    <input :class="{'is-invalid': submitted && errors.has('email')}" class="form-control"
                                           data-vv-as="Email"
                                           id="email"
                                           name="email"
                                           placeholder="Email"
                                           type="text"
                                           v-model="partner.email"
                                           v-validate="'required|email'">
                                    <div class="invalid-feedback" v-if="submitted && errors.has('email')">{{ errors.first('email') }}</div>
                                </div>
                            </div>
                        </div>
                        <div class="card-body card-blue">
                            <h6 class="card-title">Business Info</h6>

                            <div class="form-group row">
                                <label class="col-sm-3 text-right control-label col-form-label" for="biz_name">Legal Name</label>
                                <div class="col-sm-3">
                                    <input :class="{'is-invalid': submitted && errors.has('biz_name')}" class="form-control"
                                           data-vv-as="Business Name"
                                           id="biz_name"
                                           name="biz_name"
                                           placeholder="Business Name"
                                           type="text"
                                           v-model="partner.biz_name"
                                           v-validate="'required'">
                                    <div class="invalid-feedback" v-if="submitted && errors.has('biz_name')">{{ errors.first('biz_name') }}</div>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-3 text-right control-label col-form-label" for="biz_name">Description</label>
                                <div class="col-sm-7">
                                    <textarea class="form-control"
                                           id="description"
                                           name="description"
                                           rows="7"
                                           placeholder="Description"
                                           v-model="partner.description"
                                           v-validate="">
                                    </textarea>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-3 text-right control-label col-form-label" for="biz_phone">Phone</label>
                                <div class="col-sm-3">
                                    <input :class="{'is-invalid': submitted && errors.has('biz_phone')}" class="form-control"
                                           data-vv-as="Phone"
                                           id="biz_phone"
                                           name="biz_phone"
                                           placeholder="Phone"
                                           type="text"
                                           v-model="partner.biz_phone"
                                           v-validate="'required'">
                                    <div class="invalid-feedback" v-if="submitted && errors.has('biz_phone')">{{ errors.first('biz_phone') }}</div>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-3 text-right control-label col-form-label" for="biz_email">Email</label>
                                <div class="col-sm-3">
                                    <input :class="{'is-invalid': submitted && errors.has('biz_email')}" class="form-control"
                                           data-vv-as="Email"
                                           id="biz_email"
                                           name="biz_email"
                                           placeholder="Email"
                                           type="text"
                                           v-model="partner.biz_email"
                                           v-validate="'required'">
                                    <div class="invalid-feedback" v-if="submitted && errors.has('biz_email')">{{ errors.first('biz_email') }}</div>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-3 text-right control-label col-form-label" for="biz_web">Web</label>
                                <div class="col-sm-3">
                                    <input :class="{'is-invalid': submitted && errors.has('biz_web')}" class="form-control"
                                           data-vv-as="Phone"
                                           id="biz_web"
                                           name="biz_web"
                                           placeholder="Web"
                                           type="text"
                                           v-model="partner.biz_web"
                                           v-validate="'required'">
                                    <div class="invalid-feedback" v-if="submitted && errors.has('biz_web')">{{ errors.first('biz_web') }}</div>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-3 text-right control-label col-form-label" for="biz_web">DID</label>
                                <div class="col-sm-7">
                                    <input :class="{'is-invalid': submitted && errors.has('did')}" class="form-control"
                                           data-vv-as="DID"
                                           id="did"
                                           name="did"
                                           placeholder="DID"
                                           type="text"
                                           v-model="partner.did"
                                           v-validate="">
                                    <div class="invalid-feedback" v-if="submitted && errors.has('did')">{{ errors.first('did') }}</div>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-3 text-right control-label col-form-label" for="audit">Audit</label>
                                <div class="col-sm-7">
                                    <input :class="{'is-invalid': submitted && errors.has('audit')}" class="form-control"
                                           data-vv-as="Audit"
                                           id="audit"
                                           name="audit"
                                           placeholder="Audit"
                                           type="text"
                                           v-model="partner.audit"
                                           v-validate="'url'">
                                    <div class="invalid-feedback" v-if="submitted && errors.has('audit')">{{ errors.first('audit') }}</div>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-3 text-right control-label col-form-label" for="line1">Address</label>
                                <div class="col-sm-3">
                                    <input :class="{'is-invalid': submitted && errors.has('line1')}" class="form-control"
                                           data-vv-as="Address Line 1"
                                           id="line1"
                                           name="line1"
                                           placeholder="Address Line 1"
                                           type="text"
                                           v-model="partner.line1"
                                           v-validate="'required'">
                                    <div class="invalid-feedback" v-if="submitted && errors.has('line1')">{{ errors.first('line1') }}</div>
                                </div>
                                <div class="col-sm-3">
                                    <input :class="{'is-invalid': submitted && errors.has('line2')}" class="form-control"
                                           data-vv-as="Address Line 2"
                                           id="line2"
                                           name="line2"
                                           placeholder="Address Line 2"
                                           type="text"
                                           v-model="partner.line2">
                                    <div class="invalid-feedback" v-if="submitted && errors.has('line2')">{{ errors.first('line2') }}</div>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-3 text-right control-label col-form-label" for="city"></label>
                                <div class="col-sm-3">
                                    <input :class="{'is-invalid': submitted && errors.has('city')}" class="form-control"
                                           data-vv-as="City"
                                           id="city"
                                           name="city"
                                           placeholder="City"
                                           type="text"
                                           v-model="partner.city"
                                           v-validate="'required'">
                                    <div class="invalid-feedback" v-if="submitted && errors.has('city')">{{ errors.first('city') }}</div>
                                </div>
                                <div class="col-sm-3">
                                    <input :class="{'is-invalid': submitted && errors.has('state')}" class="form-control"
                                           data-vv-as="State"
                                           id="state"
                                           name="state"
                                           placeholder="State or Province"
                                           type="text"
                                           v-model="partner.state"
                                           v-validate="'required'">
                                    <div class="invalid-feedback" v-if="submitted && errors.has('state')">{{ errors.first('state') }}</div>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-3 text-right control-label col-form-label" for="postal_code"></label>
                                <div class="col-sm-3">
                                    <input :class="{'is-invalid': submitted && errors.has('postal_code')}" class="form-control"
                                           data-vv-as="Postal Code"
                                           id="postal_code"
                                           name="postal_code"
                                           placeholder="Postal Code"
                                           type="text"
                                           v-model="partner.postal_code"
                                           v-validate="'required'">
                                    <div class="invalid-feedback" v-if="submitted && errors.has('postal_code')">{{ errors.first('postal_code') }}</div>
                                </div>
                                <div class="col-sm-4">
                                    <multiselect :class="{'is-invalid': submitted && errors.has('country')}"
                                                 :options="countries"
                                                 class="form-control multiselect-sm"
                                                 data-vv-as="Country"
                                                 id="country"
                                                 label="name"
                                                 name="country"
                                                 placeholder="Country"
                                                 track-by="code"
                                                 v-model="partner.country"
                                                 v-validate="'required'">
                                    </multiselect>

                                    <div class="invalid-feedback" v-if="submitted && errors.has('country')">{{ errors.first('country') }}</div>
                                </div>
                            </div>
                        </div>
                        <div class="card">
                            <div class="card-header">
                                <div class="d-md-flex align-items-center">
                                    <div><h4 class="card-title">Attachment</h4>
                                        <h5 class="card-subtitle">Upload files of the buyer</h5>
                                    </div>
                                    <div class="ml-auto d-flex no-block align-items-center">
                                        <div class="dl">
                                            <div class="button-group"><a
                                                    @click="resetAttachment()"
                                                    class="btn waves-effect waves-light btn-info text-white"
                                                    data-target="#attachmentModal"
                                                    data-toggle="modal"><i
                                                    class="fas fa-plus"></i> Add Attachment
                                            </a></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="card-body card-blue" v-if="partner.attachments.length>0">
                                <div class="table-responsive p-t-25">
                                    <table class="table no-wrap v-middle">
                                        <thead>
                                        <tr class="bg-light">
                                            <th><h6>File Name</h6></th>
                                            <th><h6>Title</h6></th>
                                            <th><h6>Description</h6></th>
                                            <th><h6>Action</h6></th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr v-bind:key="index" v-for="(a, index) in partner.attachments">
                                            <td>{{a.filename}}</td>
                                            <td>{{a.title}}</td>
                                            <td>{{a.desc}}</td>
                                            <td>
                                                <a @click="deleteFile(a.id, a.filepath)"
                                                   class="text-danger"
                                                   href="javasript:void(0);">
                                                    <b>Remove</b>
                                                </a>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="card-body card-blue" v-else>
                                <h4 class="card-title text-muted text-center">No records found</h4></div>
                        </div>
                        <div class="card-footer">
                            <div class="form-group m-b-0 text-right">
                                <div class="button-group">
                                    <button class="btn waves-effect waves-light btn-success" type="submit">Save</button>
                                    <button @click="reset()" class="btn waves-effect waves-light btn-secondary" type="button">Reset</button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>

        <div aria-hidden="true" aria-labelledby="myModalLabel" class="modal fade" id="attachmentModal" role="dialog"
             tabindex="-1">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <form>
                        <div class="modal-header">
                            <h4 class="modal-title" id="attachmentModalLabel">Upload Attachments</h4>
                            <button aria-hidden="true" class="close"
                                    data-dismiss="modal" type="button">×
                            </button>
                        </div>
                        <div class="modal-body card-blue">
                            <div class="card-body">
                                <div class="form-group row">
                                    <div class="col-sm-12">
                                        <input
                                                class="form-control"
                                                name="file_title"
                                                placeholder="Title"
                                                style="height: 42px;"
                                                type="text"
                                                v-model="fileTitle">
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <div class="col-sm-12">
                                        <textarea
                                                class="form-control"
                                                data-vv-as="description"
                                                id="description"
                                                name="description"
                                                placeholder="File Description"
                                                rows=3
                                                v-model="fileDesc">
                                        </textarea>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <div class="input-group col-md-8">
                                        <div class="custom-file">
                                            <input @change="handleFileChange"
                                                   class="custom-file-input"
                                                   id="inputGroupFile01"
                                                   ref="attachment"
                                                   type="file">
                                            <label class="custom-file-label" for="inputGroupFile01"
                                                   style="cursor: pointer">{{filename}}</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button @click="uploadFile()" class="btn btn-success" data-dismiss="modal"
                                    type="button">Submit
                            </button>
                            <button class="btn waves-effect waves-light btn-danger"
                                    data-dismiss="modal"
                                    type="button">Cancel
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Multiselect from 'vue-multiselect';
    import {mapGetters} from "vuex";
    import countries from "../../../../../assets/js/countries";
    import axios from "axios";
    import uuid from "uuid/v4";

    export default {
        name: "AddPartner",
        components: {Multiselect},
        computed: {
            ...mapGetters(["currentUser", "currentOrg"])
        },
        data() {
            return {
                isLoading: false,
                submitted: false,
                countries: countries,
                file: null,
                fileTitle: null,
                fileDesc: null,
                partner: {
                    first_name: '',
                    last_name: '',
                    email: '',
                    biz_name: '',
                    description: null,
                    biz_phone: '',
                    biz_web: '',
                    biz_email: '',
                    did: '',
                    audit: '',
                    line1: '',
                    line2: '',
                    city: '',
                    state: '',
                    postal_code: '',
                    country: '',
                    attachments: []
                },
                filename: "Upload Attachment",
            };
        },
        mounted() {
            $(".preloader").fadeOut();
        },
        methods: {
            async save() {
                try {
                    await this.$http.put("/express/" + this.currentOrg.express_id + "/sales/buyers", this.partner);
                    this.$toastr('success', 'Buyer Added', 'Success');
                    this.$router.push({name: "buyers"});
                } catch(e) {
                }
            },
            handleSubmit(e) {
                this.submitted = true;
                this.$validator.validate()
                .then(valid => {
                    if(valid) {
                        this.save();
                    }
                });
            },
            handleFileChange(e) {
                this.file = this.$refs.attachment.files[0];
                this.filename = this.file.name;
            },
            async uploadFile() {
                try {
                    let filename = this.file.name;
                    let contenttype = this.file.type.split('/')[1];

                    // get signed url and upload file to s3;

                    let reply = await this.$http.get(`express/${this.currentOrg.express_id}/partner/signedUrl`, {
                        params:
                            {
                                type: 'write',
                                filename: filename,
                                contenttype: contenttype
                            }
                    });

                    this.partner.attachments.push({
                        id: uuid(),
                        filename: this.filename,
                        title: this.fileTitle,
                        url: reply.data.url,
                        desc: this.fileDesc,
                        filepath: reply.data.key,
                        contenttype: contenttype
                    });

                    await axios.put(reply.data.url, this.file);
                    this.resetAttachment();
                } catch (e) {

                }
            },
            async deleteFile(id, filepath) {
                try {

                    $(".preloader").fadeIn();
                    await this.$http.delete(`/express/${this.currentOrg.express_id}/partner/attachments`, {
                        data: {
                            filepath: filepath
                        }
                    });
                    _.remove(this.partner.attachments, function (a) {
                        return a.id == id;
                    });
                    this.partner.attachments = JSON.parse(JSON.stringify(this.partner.attachments));
                    $(".preloader").fadeOut();
                    this.$toastr('success', 'Attachment deleted successfully', 'Success');
                } catch (e) {
                    $(".preloader").fadeOut();
                } finally {
                    $(".preloader").fadeOut();
                }
            },
            resetAttachment() {
                this.file = null;
                this.fileTitle = null;
                this.fileDesc = null;
                this.filename = "Upload Attachment";
            }
        }
    }
</script>

<style scoped>

</style>
